import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import { withRouter } from 'next/router';
import { useIntl } from 'react-intl';
import Layout from '../components/Layout';
import withApollo from '../lib/apollo';
import loading from '../lib/loading';
import redirectToNewsAndLocalize from '../lib/redirectToNewsAndLocalize';
import messages from '../lib/messages.json';

const ThirdPartyContent = dynamic(() => import(
  '../components/ThirdPartyContent',
), {
  ssr: true,
  loading,
});

export const PartnerContentPage = () => {
  const intl = useIntl();

  return (
    <ThirdPartyContent
      title={intl.formatMessage(messages.partnerContent)}
      description={intl.formatMessage(messages.partnerContentMetaDescription)}
      route="partner-content"
      newsVariables={{
        partnerContent: true,
        featured: false,
        categoryIds: null,
      }}
    />
  );
};

PartnerContentPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

PartnerContentPage.getInitialProps = redirectToNewsAndLocalize(
  'partner-content',
);

export default withApollo(withRouter(PartnerContentPage));
